import { Injectable, NgZone } from "@angular/core";
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { UserIdleService } from "angular-user-idle";
import { TimeoutComponent } from "src/app/module/timeout/timeout.component";

@Injectable({
  providedIn: "root",
})
export class CrossTabIdleSyncService {
  private readonly idleKey = "appIdleStatus";
  private readonly lastActivityKey = "appLastActivity";
  private count: number;
  private current = this.router.url;
  private isOpen: boolean = false;

  constructor(
    private userIdle: UserIdleService,
    private ngZone: NgZone,
    private dialog: MatDialog,
    private router: Router
  ) {
    this.current = this.router.url;
    if (this.current != "/login") {
      this.initializeIdleService();
    }
    this.listenToStorageEvents();
    this.count = 0;
  }

  private initializeIdleService(): void {
    this.userIdle.startWatching();

    // Subscribe to idle start to synchronize with other tabs
    this.userIdle.onTimerStart().subscribe((count) => {
      this.count = count;
      this.setIdleStatus(true);
      //this.timeout();
    });

    // Subscribe to timeout to manage idle timeout actions
    this.userIdle.onTimeout().subscribe((val) => {
      // console.log("User has timed out due to inactivity. ");
      this.setIdleStatus(true);
      //this.logout();
      const isIdle = JSON.parse(localStorage.getItem(this.idleKey) || "false");
      this.current = this.router.url;
      if (this.current != "/login" && isIdle) {
        if (!this.isOpen) {
          // this.timeout();
        }
        this.logout();
      }
    });

    // Initialize last activity time if not present
    if (!localStorage.getItem(this.lastActivityKey)) {
      this.updateLastActivity();
    }
  }

  private listenToStorageEvents(): void {
    window.addEventListener("storage", (event) => {
      if (event.key === this.idleKey || event.key === this.lastActivityKey) {
        this.synchronizeIdleStateAcrossTabs();
      }
    });
  }

  private synchronizeIdleStateAcrossTabs(): void {
    this.ngZone.run(() => {
      const isIdle = JSON.parse(localStorage.getItem(this.idleKey) || "false");

      if (!isIdle) {
        // User has returned on another tab; reset timer in this tab
        this.userIdle.resetTimer();
        this.userIdle.startWatching();
      } else {
        // Stop watching in this tab since user is idle in another tab
        this.userIdle.stopWatching();
      }
    });
  }

  private setIdleStatus(isIdle: boolean): void {
    localStorage.setItem(this.idleKey, JSON.stringify(isIdle));
  }

  public updateLastActivity(): void {
    localStorage.setItem(this.lastActivityKey, Date.now().toString());
  }

  public get counts(): number {
    return this.count;
  }

  private timeout(): any {
    this.isOpen = true;
    const dialogConfig = new MatDialogConfig();

    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.data = {};
    const dialogref = this.dialog.open(TimeoutComponent, {
      width: "500px",
      height: "auto",
      autoFocus: true,
      disableClose: dialogConfig.disableClose,
      data: {
        counter: this.count,
      },
    });

    dialogref.afterClosed().subscribe((result: any) => {
      this.isOpen = false;
    });
  }

  private logout(): void {
    this.router.navigateByUrl("login");
    localStorage.removeItem("userinfo");
    localStorage.removeItem("token");
    localStorage.removeItem("loggedInUser");
    localStorage.removeItem("userRole");
    localStorage.removeItem("agenceinso");
    localStorage.removeItem("agence");
    // localStorage.removeItem('session');
    localStorage.removeItem("authority");
    this.router.navigateByUrl("login");
    this.dialog.closeAll();
  }
}
